import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import VariantVisibilityCard, {
  VariantVisibilityCardProps
} from "@saleor/components/VariantVisibilityCard";
import useDateLocalize from "@saleor/hooks/useDateLocalize";
import { joinDateTime, maybe, splitDateTime } from "@saleor/misc";
import React from "react";
import { useIntl } from "react-intl";

import CardSpacer from "../CardSpacer";
interface VariantAvailabilityCardProps extends VariantVisibilityCardProps {
  data: {
    availableForPurchaseDate: string;
    availableForPurchaseTime: string;
    isAvailableForPurchase: boolean;
    preOrderDate: string;
    preOrderTime: string;
    isPreOrder: boolean;
    isPublished: boolean;
    publicationDate: string;
    visibleInListings: boolean;
  };
  firstPublicationDate: any;
  Create: any;
}

export const VariantAvailabilityCard: React.FC<VariantAvailabilityCardProps> = props => {
  const intl = useIntl();
  const localizeDate = useDateLocalize();

  return (
    <>
      <VariantVisibilityCard
        {...props}
        messages={{
          ...props.messages,
          availableLabel: intl.formatMessage({
            defaultMessage: "Available for purchase",
            description: "product availability"
          }),
          availableSecondLabel: intl.formatMessage(
            {
              defaultMessage: "will become available on {date}",
              description: "product available for purchase date"
            },
            {
              date: localizeDate(
                joinDateTime(
                  props.data.availableForPurchaseDate,
                  props.data.availableForPurchaseTime
                ),
                "DD/MM/YYYY HH:mm"
              )
            }
          ),
          setAvailabilityDateLabel: intl.formatMessage({
            defaultMessage: "Set availability date",
            description: "product availability date label"
          }),
          unavailableLabel: intl.formatMessage({
            defaultMessage: "Unavailable for purchase",
            description: "product unavailability"
          }),

          preOrderLabel: intl.formatMessage({
            defaultMessage: "Preorder"
          }),
          preOrderSecondLabel: intl.formatMessage(
            {
              defaultMessage: "will arrival on {date}"
            },
            {
              date: localizeDate(
                joinDateTime(props.data.preOrderDate, props.data.preOrderTime),
                "DD/MM/YYYY HH:mm"
              )
            }
          ),
          setPreOrderDateLabel: intl.formatMessage({
            defaultMessage: "Set preorder date"
          }),
          unPreOrderLabel: intl.formatMessage({
            defaultMessage: "Not preorder"
          })
        }}
      />
      <CardSpacer />
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Date Time",
            description: "section header"
          })}
        />
        <CardContent>
          <h4>Created Time:</h4>
          {splitDateTime(maybe(() => props.Create, "")).date +
            " " +
            splitDateTime(maybe(() => props.Create, "")).time}
          <br />
          <h4>First Publication Time:</h4>
          {splitDateTime(maybe(() => props.firstPublicationDate, "")).date +
            " " +
            splitDateTime(maybe(() => props.firstPublicationDate, "")).time}
        </CardContent>
      </Card>
    </>
  );
};

export default VariantAvailabilityCard;
